import { createAsyncThunk } from '@reduxjs/toolkit';
import { ChatConnectionDetails } from 'domain/Chat';
import { getApiBaseUrl } from 'modules/api/utils';
import { updateKeycloakToken } from 'modules/keycloak';
import { keycloakService } from 'modules/keycloak/services';
import { selectActiveEventDetails } from 'store/apis/event';
import { eventApiId, toEventApiId } from 'store/apis/event/utils/eventApiId';
import { selectActiveEventId } from 'store/features/event';

import { setChatConnectionDetails } from './chatSlice';

import type { RootState } from 'store';

/**
 * Pull-based fallback: mint a chat grant from the backend when no `chat_connection_details` WS push
 * has arrived. Best-effort — a failure is swallowed so it never disrupts the rest of the join flow.
 */
export const fetchChatConnectionDetails = createAsyncThunk<void, void, { state: RootState }>(
  'chat/fetchConnectionDetails',
  async (_, { dispatch, getState }) => {
    const state = getState();
    // EventApiId (HNS-148): this is a path param on mintEventChatToken, not a WS destination.
    const eventId = toEventApiId(selectActiveEventDetails(state)) ?? eventApiId(undefined, selectActiveEventId(state));
    if (eventId === undefined) return;

    await updateKeycloakToken(keycloakService);
    const response = await fetch(`${getApiBaseUrl('v1')}/events/${eventId}/chat/token`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${keycloakService.token}` },
    });
    if (!response.ok) return;

    const details = (await response.json()) as ChatConnectionDetails;
    dispatch(setChatConnectionDetails(details));
  }
);
